import { combineReducers } from 'redux'
import selects from './selects/slice'

const staticReducer = combineReducers({
  selects,
})

export default staticReducer
